import { EsbForm } from 'src/app/services/dtos/esbForm';
import { LaboratoryBasicInfoForm } from '../../services/dtos/laboratoryBasicInfoForm';
import { LaboratoryConenctionForm } from '../../services/dtos/laboratoryConnectionForm';
import { LaboratoryEmailTemplateForm } from '../../services/dtos/laboratoryEmailTemplateForm';

export class FetchTemplateTypesIfEmpty {
  public static readonly type = '[Laboratories] Fetch All Template Types if empty';
}

export class FetchAllLaboratoriesBasicInfo {
  public static readonly type = '[Laboratories] Fetch All Basic Infos';
}

export class FetchCurrentUserLaboratoriesBasicInfo {
  public static readonly type = '[Laboratories] Fetch Current User Basic Infos';
}

export class FetchLaboratory {
  public static readonly type = '[Laboratories] Fetch Single';
  public constructor(public id: string) { }
}

export class SetCurrentLaboratoryId {
  public static readonly type = '[Laboratories] Set Current Laboratory Id';
  public constructor(public id: string) { }
}

export class ClearCurrentLaboratoryId {
  public static readonly type = '[Laboratories] Clear Current Laboratory Id';
}

export class AddLaboratoryEmailTemplate {
  public static readonly type = '[Laboratories] Add Email Template';
  public constructor(public payload: LaboratoryEmailTemplateForm) { }
}

export class UpdateLaboratoryEmailTemplate {
  public static readonly type = '[Laboratories] Update Email Template';
  public constructor(public payload: LaboratoryEmailTemplateForm) { }
}

export class DeleteLaboratoryEmailTemplate {
  public static readonly type = '[Laboratories] Delete Email Template';
  public constructor(public laboratoryId: string, public templateId: string) { }
}

export class GetLaboratoryEmailTemplateFile {
  public static readonly type = '[Laboratories] Get Email Template File';
  public constructor(public laboratoryId: string, public templateId: string) { }
}

export class AddLaboratoryConnection {
  public static readonly type = '[Laboratories] Add Connection';
  public constructor(public payload: LaboratoryConenctionForm) { }
}

export class UpdateLaboratoryConnection {
  public static readonly type = '[Laboratories] Update Connection';
  public constructor(public payload: LaboratoryConenctionForm) { }
}

export class DeleteLaboratoryConnection {
  public static readonly type = '[Laboratories] Delete Connection';
  public constructor(public laboratoryId: string, public connectionId: string) { }
}

export class AddLaboratory {
  public static readonly type = '[Laboratories] Add';
  public constructor(public laboratoryBasicInfoForm: LaboratoryBasicInfoForm) { }
}

export class UpdateLaboratory {
  public static readonly type = '[Laboratories] Update';
  public constructor(public laboratoryBasicInfoForm: LaboratoryBasicInfoForm) { }
}

export class DeleteLaboratory {
  public static readonly type = '[Laboratories] Delete';
  public constructor(public id: string) { }
}

export class DeleteLaboratoryEsb {
  public static readonly type = '[Laboratories] Delete eESB';
  public constructor(public laboratoryId: string, public esbId: string) { }
}

export class UpdateLaboratoryEsb {
  public static readonly type = '[Laboratories] Update eESB';
  public constructor(public payload: EsbForm) { }
}

export class AddLaboratoryEsb {
  public static readonly type = '[Laboratories] Add eESB';
  public constructor(public payload: EsbForm) { }
}

export class DeleteLaboratoryLogs {
  public static readonly type = '[Laboratories] Delete logs';
  public constructor(public id: string) { }
}

export class DeleteLaboratoryTasks {
  public static readonly type = '[Laboratories] Delete tasks';
  public constructor(public id: string) { }
}